import { faker } from '@faker-js/faker'
import defaultUser from 'assets/img/default-user.jpg'
import { useUser } from 'contexts/UserContext'
import useClickOutside from 'hooks/useClickOutside'
import PropTypes from 'prop-types'
import { useState } from 'react'
import { LuPanelLeftClose, LuPanelLeftOpen } from 'react-icons/lu'
import { useLocation } from 'wouter'
import Title from '../Title/Title'

export default function Navbar({ isSidebarOpen, setIsSidebarOpen }) {
  // Hook para gestionar el usuario actual
  const { user } = useUser()

  // Wouter - useLocation() permite cambiar de pantalla
  const [, setLocation] = useLocation()

  // Hook personalizado principalmente para cerrar el modal de perfil (ubicado en la esquina superior derecha)
  // al hacer clic fuera de él, pero se puede usar en más casos si se necesita, esto soluciona el problema de que el modal no se cerraba automáticamente.
  const dropRef = useClickOutside(() => setOpenUserDropdown(false))

  // Estado que indica si el tema principal es claro o oscuro
  const [darkTheme, setDarkTheme] = useState(false)

  // Estado que indica si el modal de perfil está abierto
  const [openUserDropdown, setOpenUserDropdown] = useState(false)

  // Imagen random para hacer pruebas proporcionada por el paquete 'faker'
  const image = faker.image.url()

  return (
    <nav
      className={`z-50 fixed h-20 ${isSidebarOpen ? 'pl-0 md:pl-60' : 'pl-0 md:pl-24'} flex justify-center items-center top-0 w-full bg-[#006F53] dark:bg-[#38393D] duration-100`}
    >
      <div className="flex items-center justify-between w-full px-4 py-2 mx-auto md:py-0">
        <div>
          <div className="flex flex-row items-center justify-center m-0">
            <div
              className={`md:hidden pr-2 flex flex-row items-center justify-center m-0`}
            >
              {!isSidebarOpen ? (
                <LuPanelLeftOpen
                  className={`text-white cursor-pointer hover:text-[#4a9e7e]`}
                  size={30}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              ) : (
                <LuPanelLeftClose
                  className={`text-white cursor-pointer hover:text-[#4a9e7e]`}
                  size={30}
                  onClick={() => setIsSidebarOpen((prev) => !prev)}
                />
              )}
            </div>

            {/* 
              Renderiza el componente Title para mostrar el título de la página, es parecido al 'ToasContainer'.
              Puedes cambiar el título en cualquier otro componente con 'setTitle' y se va a mostrar aquí.  
            */}
            <Title />
          </div>
        </div>

        <div className="flex flex-row items-center justify-end space-x-9">
          <div
            ref={dropRef}
            className="flex flex-col items-center space-x-3 md:order-2 md:space-x-0 rtl:space-x-reverse"
          >
            <button
              type="button"
              className="flex text-sm rounded-full md:me-0 focus:ring-opacity-90 focus:outline-none focus:ring focus:ring-gray-500 focus:border-gray-500 dark:focus:border-gray-500"
              onClick={() => setOpenUserDropdown((prev) => !prev)}
            >
              <img
                className="object-cover w-12 h-12 rounded-full"
                src={user?.profile_picture || defaultUser}
              />
            </button>

            <div
              className={`absolute top-14 right-4 z-50 ${!openUserDropdown && 'hidden'} my-4 text-base list-none bg-white divide-y divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600`}
            >
              <div className="px-4 py-3">
                <span className="block text-sm text-gray-900 dark:text-white">
                  {user?.first_name + ' ' + user?.last_name}
                </span>

                <span className="block text-sm text-gray-500 truncate dark:text-gray-400">
                  {user?.username}
                </span>
              </div>

              <ul className="py-2">
                <li>
                  <label className="inline-flex items-center px-4 py-2 cursor-pointer">
                    <input
                      type="checkbox"
                      className="sr-only peer"
                      onClick={(e) => {
                        e.stopPropagation()

                        // Alterna el tema de la aplicación entre claro y oscuro
                        document.body.classList.toggle('dark')
                        setDarkTheme((prev) => !prev)
                      }}
                    />

                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 rounded-full peer peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all peer-checked:bg-blue-600"></div>

                    <span className="text-sm text-gray-700 dark:text-gray-200 ms-3">
                      {darkTheme ? 'Tema fosc' : 'Tema clar'}
                    </span>
                  </label>
                </li>

                <li>
                  <a
                    href="#"
                    className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 dark:hover:bg-gray-600 dark:text-gray-200 dark:hover:text-white"
                    onClick={() => setLocation('/logout')}
                  >
                    Tancar sessió
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </nav>
  )
}

// Define los tipos de las props que recibe el componente actual
Navbar.propTypes = {
  isSidebarOpen: PropTypes.any,
  setIsSidebarOpen: PropTypes.func
}
